const safeParse = (value) => {
  try {
    return JSON.parse(value);
  } catch (_e) {
    return value;
  }
};

export default safeParse;
